import { makeStyles, shorthands, tokens } from "@fluentui/react-components";

export const useStyles = makeStyles({
  errorBoundaryContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    width: "70%",
    ...shorthands.padding("20px"),
    alignSelf: "center",
    textAlign: "center",
    color: tokens.colorNeutralForeground2,
    backgroundColor: tokens.colorNeutralBackground3,
  },
  image: {
    width: "150px",
    height: "150px",
    flexShrink: 0,
    ...shorthands.border("1px", "transparent"),
    ...shorthands.borderRadius("8px"),
    ...shorthands.margin("10px"),
  },
  textMessage: {
    textAlign: "center",
    paddingBottom: "20px",
  },
  subtextMessage: {
    textAlign: "center",
    paddingBottom: "20px",
    color: tokens.colorBrandShadowAmbient,
  },
});
